/**
 * Tema claro/escuro. Comportamento igual ao da v67: **escuro por padrão** e a escolha
 * fica guardada no navegador. A classe vai no `<html>` porque os tokens do estilo.css
 * são redefinidos em `.dark` na raiz.
 */
const CHAVE = 'fincastTema';

export function temaEscuro(): boolean {
  return document.documentElement.classList.contains('dark');
}

function aplicar(escuro: boolean): void {
  document.documentElement.classList.toggle('dark', escuro);
}

export function alternarTema(): boolean {
  const escuro = !temaEscuro();
  aplicar(escuro);
  try {
    localStorage.setItem(CHAVE, escuro ? 'dark' : 'light');
  } catch {
    /* navegador com armazenamento bloqueado: o tema vale só nesta aba */
  }
  return escuro;
}

export function iniciarTema(): void {
  let salvo: string | null = null;
  try {
    salvo = localStorage.getItem(CHAVE);
  } catch {
    salvo = null;
  }
  aplicar(salvo === null ? true : salvo === 'dark');
}
